<template>
  <div id="app">
    <router-view></router-view>

    <WhatsappButton />
  </div>
</template>

<script>
import WhatsappButton from '@/components/WhatsappButton'

export default {
  name: 'app',

  components: {
    WhatsappButton
  }
}
</script>

<style lang="sass">
  @import '@/assets/sass/_base.sass'
  @import '@/assets/sass/_reset.sass'
  @import '@/assets/sass/_animate.sass'

  body.overflow-hidden
    overflow: hidden
</style>
